import RadioButton from 'components/atoms/radioButton';
import PropTypes from 'prop-types';

const RadioInput = ({
  id,
  title,
  setValue,
  values,
  isRequired,
  disabled,
  hasOtherOption,
  choices,
}) => {
  const otherInputValue =
    hasOtherOption && choices.find((choice) => choice === values[id])
      ? ''
      : values[id];
  return (
    <div className="input-wrapper">
      <label htmlFor={id}>
        {title} {isRequired && <span className="color-red">*</span>}
      </label>
      {choices.map((choice) => (
        <RadioButton
          id={`${id}${choice}`}
          label={choice}
          isChecked={values[id] === choice}
          onChange={() => {}}
          onClick={() => {
            if (values[id] === choice) {
              setValue({ [id]: undefined });
            } else {
              setValue({ [id]: choice });
            }
          }}
          key={`${id}${choice}`}
          name={`${id}${choice}`}
          disabled={disabled}
        />
      ))}
      {hasOtherOption && (
        <div className="other-input-wrapper">
          <label htmlFor={id}>Other:</label>
          <input
            id={id}
            className="form-control"
            type="text"
            autoComplete="off"
            disabled={disabled}
            value={otherInputValue || ''}
            onChange={(e) => {
              setValue({ [id]: e.target.value });
            }}
          />
        </div>
      )}
    </div>
  );
};

RadioInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  choices: PropTypes.array,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  hasOtherOption: PropTypes.bool,
  disabled: PropTypes.bool,
  values: PropTypes.shape(),
};

export default RadioInput;
